module.exports = __webpack_public_path__ + "static/media/notebook05.37a76cf8.jpg";